// OMNISCIENT (8000) and up. The one place the admin role threshold lives on
// the client — every admin route's userFilter points here, and so does any
// page that shows admins more than it shows everyone else.
export const isAdmin = (user: any): boolean => user?.user_role >= 8000;
